// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b3f87358","977":"d658f77c"}[chunkId] + ".chunk.js";
};